import { MetaData, SpecialistsPage } from '@/components'

export default function NextSpecialistsPage(props) {
  const { meta } = props.paginator;
  const { title: titleFromProps, description: descFromProps } = meta;
  const title = titleFromProps || "ELEMENTAL Day Surgical Center Specialists";
  const description = descFromProps || "ELEMENTAL Day Surgical Center"

  return (
    <>
      <MetaData title={title} description={description}/>
      <SpecialistsPage {...props} />
    </>
  )
}

NextSpecialistsPage.getInitialProps = async ({ query, api }) => {
  const { page, ...queries } = query
  const response = await api.specialists(page, queries)

  const { directions, ...paginator } = response
  return { directions, paginator }
}
